import React from "react";
import { Button } from "@mui/material";

import AppConfirmDialog from "components/Shared/AppConfirmDialog";

import { useAuth } from "hooks";

const PopulatePerformancePoints = ({
  isBusy = false,
  listDetail,
  onPopulateOptions = async () => {},
}) => {
  const [showDialog, setShowDialog] = React.useState(false);

  const { viewEntity } = useAuth();

  const _mappedListOptions = React.useMemo(
    () =>
      listDetail?.defaults?.map((el) => ({
        account: viewEntity?.entity?.account?._id,
        type: listDetail?.value,
        name: el,
        level: 1,
        maxLevel: listDetail?.maxLevel || 2,
        parentName: listDetail?.value,
        value: listDetail?.valueType === "Number" ? 0 : "",
      })),
    [listDetail, viewEntity?.entity?.account?._id]
  );

  // methods
  const handlePopulatePerformancePoints = async () => {
    if (!_mappedListOptions?.length) return;

    await onPopulateOptions(_mappedListOptions);

    setShowDialog(false);
  };

  if (!listDetail?.defaults?.length) return null;

  return (
    <>
      <Button variant="outlined" onClick={() => setShowDialog(true)}>
        Populate Defaults
      </Button>

      <AppConfirmDialog
        maxWidth="xs"
        title={`Populate ${listDetail?.value}?`}
        open={showDialog}
        onConfirm={handlePopulatePerformancePoints}
        onClose={() => setShowDialog(false)}
        loading={isBusy}
        loadingText={`Populating ${listDetail?.value} options`}
      >
        <div>
          Are you sure you want to populate {listDetail?.value} with the
          following options?
        </div>

        {listDetail?.defaults?.map((el) => (
          <div key={el} className="ml-4">
            - {el}
          </div>
        ))}
      </AppConfirmDialog>
    </>
  );
};

export default PopulatePerformancePoints;
